import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import useGetCustomerPaymentLogs from '@/features/payment-management/customer-payment-logs/hooks/useGetCustomerPaymentLogs';
import { CustomerPaymentTable } from '@/features/payment-management/customer-payment-logs/table';
import { Translation } from '@/hoslog-intl';
import { FileIcon } from '@/icons';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'requestID',
    'userInfo',
    'emailAddress',
    'phoneNumber',
    'requestDate',
    'requestedAmount',
    'approvalDate',
    'remarks',
    'status',
  ]),
  desc: z.boolean(),
});

const CustomerPaymentLogsSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  requestedDate: z
    .string()

    .optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),
  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/payment-management/customer-payment-logs/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="paymentManagement.customerPaymentLogs.crumb.customerPaymentLogs" icon={FileIcon} />,
      title: <Translation id="paymentManagement.customerPaymentLogs.page.title" />,
    };
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => CustomerPaymentLogsSchema.parse(search),
});

function RouteComponent() {
  const { customerPaymentLogs, isLoading, pagination } = useGetCustomerPaymentLogs();
  return <CustomerPaymentTable data={customerPaymentLogs} pagination={pagination} loading={isLoading} />;
}
